/*
 * @Author: Yun
 * @Date: 2024-02-16 11:15:48
 * @Last Modified by: Yun
 * @Last Modified time: 2024-02-27 14:39:59
 */
import React from 'react'
import txt from '@images/welcome/txt.png'
import person from '@icons/person2.png'
import './index.less'

const PREFIX = 'welcome-page'

const WelcomePage = (props) => {
    const { id } = props

    return (
        <section className={PREFIX} id={id}>
            <img className={`${PREFIX}-txt`} src={txt} alt="" />
            <img className={`${PREFIX}-person`} src={person} alt="" />
        </section>
    )
}

export default WelcomePage
